import React, { useState } from 'react';
import axios from 'axios';
import { FileXls, FilePdf } from '@phosphor-icons/react';
import { notify } from '../../lib/notify';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// One-click Excel / PDF download of the current range.
export default function ExportButtons({ range }) {
  const [busy, setBusy] = useState('');
  const download = async (format) => {
    setBusy(format);
    try {
      const r = await axios.get(`${API}/profitability/export`, {
        params: { format, start_month: range.start, end_month: range.end }, responseType: 'blob',
      });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `profitability_${range.start}_${range.end}.${format}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      notify('Export failed', 'error');
    } finally { setBusy(''); }
  };
  const cls = 'inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-[#D5E8E4] bg-white text-[#052A23] text-sm font-medium hover:bg-[#F4F9F7] transition-colors disabled:opacity-60';
  return (
    <>
      <button type="button" onClick={() => download('xlsx')} disabled={!!busy} className={cls} data-testid="profit-export-xlsx-btn">
        <FileXls size={16} className="text-emerald-700" /> {busy === 'xlsx' ? 'Exporting…' : 'Excel'}
      </button>
      <button type="button" onClick={() => download('pdf')} disabled={!!busy} className={cls} data-testid="profit-export-pdf-btn">
        <FilePdf size={16} className="text-rose-600" /> {busy === 'pdf' ? 'Exporting…' : 'PDF'}
      </button>
    </>
  );
}
